import React from 'react'
import { Message } from '@paypalcorp/worldready-react'
import { isFeatureEnabled, hasTreatmentName } from '../utils'
import { Badge } from '@paypalcorp/pp-react'
import serverData from '../utils/server-data'
import { dataPlatformConfig } from './data-privacy-data-platform'

const { userInfo = {} } = serverData,
  isMerchantUser = serverData.isMerchantUser,
  enabledForDownloadData = isFeatureEnabled('enabledForDownloadData'),
  enabledForCorrectData = isFeatureEnabled('enabledForCorrectData'),
  enabledForDeleteData =
    isFeatureEnabled('enabledForDeleteData') && !isMerchantUser,
  enabledForManageDataSection =
    enabledForDownloadData || enabledForCorrectData || enabledForDeleteData,
    isInFrame = serverData.isInFrame,
  { businessType = '', isSecondaryUser = false } = userInfo,
  subsectionComponent =
    serverData.selectedComponent === 'dw2' ? 'dw2' : 'default'

const allowedBusinessTypes = {
  INDIVIDUAL: true,
  PROPRIETORSHIP: true,
}

const isDataSectionCanbeShown = () => {
  let flag = false
  if (isMerchantUser) {
    if (!isSecondaryUser && allowedBusinessTypes[businessType.toUpperCase()]) {
      flag = true
    } else {
      flag = false
    }
  } else {
    flag = true
  }
  return enabledForManageDataSection && flag
}

const pickElmoForDatasection = () => {
  let flag = false
  if (isMerchantUser) {
    flag = hasTreatmentName('Trmt_Merchant_Manage_Data_Section')
  } else {
    flag =
      hasTreatmentName('Trmt_Manage_Data_Section') ||
      hasTreatmentName('Trmt_Manage_Data_Deletion') ||
      hasTreatmentName('Trmt_Manage_Data_Correction')
  }
  return flag
}

const dataPlatformSections = [
  {
    sectionId: 'manageyourdata',
    sectionName: <Message id="privacy.data.sectionName" />,
    badge: {
      type: 'feature',
      text: <Message id="privacy.badge.new" />,
    },
    isEnabled: isDataSectionCanbeShown(),
    domid: 'manageyourdata',
    hasElmoTreatment: pickElmoForDatasection(),
    enabledCountries: [],
    subSections: [
      {
        subSectionId: 'download_data',
        title: <Message id="privacy.downloadData.title" />,
        desc: <Message id="privacy.downloadData.description" />,
        iconName: dataPlatformConfig.downloadData[subsectionComponent].iconName,
        domid: 'download_data',
        featureEnabled: enabledForDownloadData, //rcs service
        hasElmoTreatment: isMerchantUser
          ? hasTreatmentName('Trmt_Merchant_Manage_Data_Section')
          : hasTreatmentName('Trmt_Manage_Data_Section'),
        navigateTo: isInFrame && isMerchantUser
          ? `/myaccount/privacy/data/dar?inframe=${isInFrame}`
          : '/myaccount/privacy/data/dar',
        fptiClickData: {
          pgrp: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy'
            : 'main:dataprivacy:home',
          page: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy'
            : 'main:dataprivacy:home',
          pglk: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy|download_data'
            : 'main:dataprivacy:home|download_data',
          pgln: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy|download_data'
            : 'main:dataprivacy:home|download_data',
          comp: isMerchantUser ? 'bizmanagenodeweb' : 'privacynodeweb',
          link: 'download_data',
        },
        action: <Message id="privacy.merchant.action.createRequest" />,
      },
      {
        subSectionId: 'correct_data',
        title: <Message id="privacy.correctData.title" />,
        desc: <Message id="privacy.correctData.description" />,
        iconName: dataPlatformConfig.correctData[subsectionComponent].iconName,
        domid: 'correct_data',
        featureEnabled: enabledForCorrectData,
        hasElmoTreatment: isMerchantUser
          ? hasTreatmentName('Trmt_Merchant_Manage_Data_Section')
          : hasTreatmentName('Trmt_Manage_Data_Correction'),
        navigateTo: isInFrame && isMerchantUser
          ? `/myaccount/privacy/data/dar/correction?inframe=${isInFrame}`
          : '/myaccount/privacy/data/dar/correction',
        fptiClickData: {
          pgrp: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy'
            : 'main:dataprivacy:home',
          page: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy'
            : 'main:dataprivacy:home',
          pglk: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy|correct_data'
            : 'main:dataprivacy:home|correct_data',
          pgln: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy|correct_data'
            : 'main:dataprivacy:home|correct_data',
          comp: isMerchantUser ? 'bizmanagenodeweb' : 'privacynodeweb',
          link: 'correct_data',
        },
        action: <Message id="privacy.merchant.action.update" />,
      },
      {
        subSectionId: 'delete_data',
        title: (
          <Message
            id={
              isMerchantUser
                ? 'privacy.merchant.deleteData.title'
                : 'privacy.deleteData.title'
            }
          />
        ),
        desc: <Message id="privacy.deleteData.description" />,
        iconName: dataPlatformConfig.deleteData[subsectionComponent].iconName,
        domid: 'delete_data',
        featureEnabled: enabledForDeleteData,
        navigateTo: isInFrame && isMerchantUser
          ? `/myaccount/privacy/data/deletion?inframe=${isInFrame}`
          : '/myaccount/privacy/data/deletion',
        hasElmoTreatment: hasTreatmentName('Trmt_Manage_Data_Deletion'),
        fptiClickData: {
          pgrp: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy'
            : 'main:dataprivacy:home',
          page: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy'
            : 'main:dataprivacy:home',
          pglk: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy|delete_data'
            : 'main:dataprivacy:home|delete_data',
          pgln: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy|delete_data'
            : 'main:dataprivacy:home|delete_data',
          comp: isMerchantUser ? 'bizmanagenodeweb' : 'privacynodeweb',
          link: 'delete_data',
        },
        action: <Message id="privacy.merchant.action.createRequest" />,
      },
    ],
  },
]

// this submodule has to retrieved from /api and will be served via serverData
dataPlatformSections[0].subSections[0].subModule = {
  subModuleId: 'data_request_history',
  title: <Message id="dar.history.header.title" />,
  desc: <Message id="dar.history.header.desc" />,
  badgeName: 'download',
  badgeFeature: 'feature',
  action: <Message id="privacy.merchant.action.view" />,
  domid: 'data_request_history',
  fptiClickData: {
    pgrp: isMerchantUser
      ? 'main:businessweb:profile:dataprivacy'
      : 'main:dataprivacy:home',
    page: isMerchantUser
      ? 'main:businessweb:profile:dataprivacy'
      : 'main:dataprivacy:home',
    link: 'your_request',
  },
  modal: {
    name: 'dataRequestHistory',
  },
  navigateTo: isInFrame && isMerchantUser
    ? `/myaccount/privacy/data/dar/yourrequests?inframe=${isInFrame}`
    : '/myaccount/privacy/data/dar/yourrequests',
  enabled: () => {
    return Object.keys(serverData.darHistory).length > 0
  },
  badgeStatus: () => {
    const DARSTATUS = {
      OPEN: (
        <Badge
          type={
            dataPlatformConfig.downloadData[subsectionComponent].badge.open.type
          }
          className={
            dataPlatformConfig.downloadData[subsectionComponent].badge.open
              .className
          }
          theme="v2"
        >
          <Message id="dar.history.request.status.open" />
        </Badge>
      ),
      INPROGRESS: (
        <Badge
          type={
            dataPlatformConfig.downloadData[subsectionComponent].badge.progress
              .type
          }
          className={
            dataPlatformConfig.downloadData[subsectionComponent].badge.progress
              .className
          }
          theme="v2"
        >
          <Message id="dar.history.request.status.progress" />
        </Badge>
      ),

      CLOSED: (
        <Badge
          type={
            dataPlatformConfig.downloadData[subsectionComponent].badge.download
              .type
          }
          className={
            dataPlatformConfig.downloadData[subsectionComponent].badge.download
              .className
          }
          theme="v2"
        >
          <Message id="dar.history.request.status.download" />
        </Badge>
      ),
    }
    return DARSTATUS[
      Object.keys(serverData.darHistory).length > 0 &&
        serverData.darHistory[0].status
    ]
  },
}

export default dataPlatformSections
